import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/core/auth/auth.service";
import {
  ApiService,
  CreateReservationParams,
} from "src/app/core/http/api.service";

@Component({
  selector: "app-availability",
  templateUrl: "./availability.component.html",
  styles: ``,
})
export class AvailabilityComponent implements OnInit {
  public reason: string;
  public referralCode: string;
  public busy = false;
  public submitted = false;

  public notifyForm: FormGroup;
  public error: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private fb: FormBuilder
  ) {
    this.notifyForm = this.fb.group(
      {
        email: [undefined, [Validators.required, Validators.email]],
      },
      { updateOn: "blur" }
    );
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((p) => {
      this.reason = p["reason"] || null;
      this.referralCode = p["r"] || null;
    });
  }

  createReservation() {
    // check if form is valid
    this.error = false;

    if (!this.notifyForm.valid) {
      this.notifyForm.markAllAsTouched();
      return;
    }
    this.busy = true;

    this.busy = true;

    const params: CreateReservationParams = {
      email: this.email.value,
      marketing_consent: false,
      referral_code: this.referralCode,
    };
    this.apiService.createReservation(params).subscribe(
      () => {
        this.submitted = true;
        this.busy = false;
      },
      () => {
        this.error = true;
        this.busy = false;
      }
    );
  }

  public get email() {
    return this.notifyForm.get("email") as FormControl;
  }
}
